export default __webpack_public_path__ + "static/media/bg2.7d42f210.jpg";